/* ************** getters ***********************/
export const GET_INFO = 'GET_INFO'
export const GET_TOKEN = 'GET_TOKEN'
export const GET_USER = 'GET_USER'
export const GET_LOADERS = 'GET_LOADERS'
export const GET_MARGIN_CALCULATOR_LIST = 'GET_MARGIN_CALCULATOR_LIST'


/* ************** mutations - setters ***********************/
export const SET_INFO = 'SET_INFO'
export const SET_STATE = 'SET_STATE'
export const SET_TOGGLE_LOADER = 'SET_TOGGLE_LOADER'
export const SET_MARGIN_CALCULATOR_LIST = "SET_MARGIN_CALCULATOR_LIST"

/** *************** actions - asynchronous ***********************/

export const RUN_PAN_VERIFY					= 'RUN_PAN_VERIFY'
export const RUN_CREATE_LEAD					= 'RUN_CREATE_LEAD'
export const RUN_VERIFY_LEAD_OTP					= 'RUN_VERIFY_LEAD_OTP'
export const RUN_VERIFY_DOB					= 'RUN_VERIFY_DOB'
export const RUN_FETCH_DOB					= 'RUN_FETCH_DOB'
export const RUN_MARGIN_CALCULATOR			= 'RUN_MARGIN_CALCULATOR'
export const RUN_CONTACT_US         = 'RUN_CONTACT_US'
export const RUN_AI_STOCK_EMAIL         = 'RUN_AI_STOCK_EMAIL'
export const RUN_WEB_ENGAGE_USER           =   'RUN_WEB_ENGAGE_USER'
export const RUN_STATUS_CVL                =  'RUN_STATUS_CVL'
export const RUN_RSS_FEED                =  'RUN_RSS_FEED'


// WEBPACK FOOTER //
// ./src/types.js